<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else class="my-5">
    <h1 class="text-center">Reset Password</h1>
    <div class="form p-5 mb-5">
      <div class="row">
        <div class="col">
          <label for="inputUserName">เบอร์โทร/อีเมล/รหัสลูกค้า</label>
          <input
            id="inputUserName"
            type="text"
            v-model="username"
            class="form-control"
            :class="{
              'input--error':
                isValid & (username === '') || fieldError.username
                  ? true
                  : false,
            }"
          />
          <div v-if="isValid && username === ''" class="text-error">
            กรุณากรอกเบอร์โทรศัพท์
          </div>
          <div v-if="fieldError.username" class="text-error">
            {{ fieldError.username }}
          </div>
        </div>
        <div class="col">
          <label for="inputPhoneNumber"
            >เบอร์โทรศัพท์มือถือที่ต้องการรับลิงค์เพื่อ reset password</label
          >
          <input
            id="inputPhoneNumber"
            type="text"
            v-model="phone"
            class="form-control"
            :class="{ 'input--error': isValid && !phone }"
            maxlength="10"
            placeholder="08X XXX XXXX (ไม่ต้องใส่ขีด - )"
          />
          <div v-if="isValid && !phone" class="text-error">
            กรุณากรอกเบอร์โทรศัพท์ที่ต้องการส่งข้อความ
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="inputBirthday">วันเดือนปีเกิด (พ.ศ.)</label>
          <date-picker
            id="inputBirthday"
            v-bind="$attrs"
            v-model="picker"
            :class="{ 'input--error': isValid }"
            format="D MMMM yyyy"
            :value="picker"
            @change="picker = $event"
            :validate="fieldError.birthday ? true : false"
          />
          <div class="text-error" v-if="fieldError.birthday">
            {{ fieldError.birthday }}
          </div>
        </div>
        <div class="col">
          <label for="inputBirthdayConfirm">วันเดือนปีเกิด (ค.ศ.)</label>
          <date-picker
            id="inputBirthdayConfirm"
            v-bind="$attrs"
            v-model="picker"
            :class="{ 'input--error': isValid }"
            format="D MMMM yyyy"
            :value="picker"
            lang="en"
            @change="picker = $event"
            :validate="fieldError.birthday ? true : false"
          />
          <div class="text-error" v-if="fieldError.birthday">
            {{ fieldError.birthday }}
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end my-10">
        <button
          class="btn btn-outline-dark mx-15"
          style="width: 15%"
          @click="clearData"
        >
          reset
        </button>
        <button
          class="btn btn-outline-success"
          style="width: 15%"
          @click="checkValidate"
        >
          OK
        </button>
      </div>
    </div>
    <v-alert prominent type="success" v-if="isAlertSuccess">
      Reset Password เรียบร้อย
    </v-alert>
    <v-alert prominent type="error" v-if="isAlertFail">
      {{ msgError }}
    </v-alert>
  </div>
</template>

<script>
import moment from "moment";
import customerService from "@/services/api/customer.service";
const currYear = moment().format("YYYY");
export default {
  data() {
    return {
      username: "",
      picker: moment(`${currYear}-01-01`)
        .add(-30, "years")
        .format("YYYY-MM-DD"),
      phone: null,
      isLoading: false,
      isAlertSuccess: false,
      isAlertFail: false,
      msgError: "",
      isValid: false,
      fieldError: {
        user: "",
        birthday: "",
        phone: "",
      },
    };
  },
  computed: {
    permission() {
      return localStorage.getItem("user_roles");
    },
  },
  methods: {
    clearData() {
      this.isAlertFail = false;
      this.resetData();
    },
    resetData() {
      this.username = "";
      this.picker = moment().format("YYYY-MM-DD");
      this.phone = null;
      this.isValid = false;
      this.fieldError = {
        user: "",
        birthday: "",
        phone: "",
      };
    },
    checkValidate() {
      if (this.username === "" || this.phone === null) {
        this.isValid = true;
      } else {
        this.submitResetPassword();
      }
    },
    async submitResetPassword() {
      this.isLoading = true;
      const body = {
        userIdentity: this.username,
        birthday: moment(this.picker).format("D/M/YYYY"),
        mobileForSendingLink: this.phone,
      };
      await customerService
        .forgotPassword(body)
        .then((res) => {
          const data = res.data;
          if (data.status === "failure") {
            this.msgError = data.message || "ไม่สามารถ Reset Password ได้";
            this.isAlertFail = true;
            this.isAlertSuccess = false;
            if (data.errors) this.setErrorText(data.errors);
          } else {
            this.isAlertSuccess = true;
            this.isAlertFail = false;
            this.resetData();
            setTimeout(() => {
              this.isAlertSuccess = false;
            }, 5000);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Error: ", error);
          this.msgError = error;
          this.isAlertFail = true;
          this.isAlertSuccess = false;
          this.isLoading = false;
        });
    },
    setErrorText(data) {
      this.fieldError.birthday = data.find(
        (i) => i.fieldName === "birthday"
      )?.message;
      this.fieldError.username = data.find(
        (i) => i.fieldName === "userIdentity"
      )?.message;
    },
  },
  watch: {
    phone: {
      handler: function (val) {
        this.phone = val && val.replaceAll(/\D/, "");
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin: auto;
  width: 80%;
  padding: 10px;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}

.input--error {
  border-color: red;
}
.text-error {
  font-size: 12px;
  color: red;
}
</style>
<style>
.input--error > .input-group > .form-control {
  border-color: red !important;
}
</style>
